import React, { useEffect, useState } from "react";
import axios from "axios";
import * as XLSX from "xlsx";

const Date_Wise_Ben_Ver = ({ date }) => {

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(50);

    //  Format date
    const getFormattedDate = () => {
        if (!date) return "";
        const [year, month, day] = date.split("-");
        return `${day}-${month}-${year}`;
    };

    useEffect(() => {
        fetchData();
        setPage(0);
    }, [date]);

    //  Fetch API
    const fetchData = async () => {
        setLoading(true);
        try {
            const [year, month, day] = date.split("-");
            const monthInt = parseInt(month, 10);
            const formattedDate = `${day}-${month}-${year}`;

            const res = await axios.get(
                `${process.env.REACT_APP_URL_HEADER}/api/beneficiary/date-wise`,
                {
                    params: {
                        date: formattedDate,
                        month: monthInt,
                        year: year
                    }
                }
            );

            setData(res.data || []);
        } catch (err) {
            console.error(err);
            alert("Error fetching data");
        }
        setLoading(false);
    };

    // Pagination logic
    const paginatedData =
        rowsPerPage === "all"
            ? data
            : data.slice(
                page * rowsPerPage,
                page * rowsPerPage + rowsPerPage
            );


    const total = data?.length || 0;

    const start =
        rowsPerPage === "all"
            ? total === 0 ? 0 : 1
            : total === 0
                ? 0
                : page * rowsPerPage + 1;

    const end =
        rowsPerPage === "all"
            ? total
            : Math.min((page + 1) * rowsPerPage, total);


    //  Excel export
    const exportExcel = () => {
        const table = document.getElementById("excel");
        const wb = XLSX.utils.table_to_book(table, { sheet: "Aadhaar" });
        XLSX.writeFile(wb, "Beneficiary_Aadhaar_Modified_Report.xlsx");
    };

    return (
        <div style={{ width: "90%", margin: "auto" }}>

            {loading && <h3>Loading...</h3>}

            {!loading && data.length === 0 && <h3>No Data Found</h3>}

            {!loading && data.length > 0 && (
                <>
                    {/*  Excel Button */}
                    <div align="left" style={{ marginBottom: "10px" }}>
                        <button className="button button2" onClick={exportExcel}>
                            Download Excel
                        </button>
                    </div>

                    {/* Table */}
                    <table id="excel" class="display nowrap" border="1" style={{ width: "100%", textAlign: "center" }}>
                        <thead>
                            <tr className="tableheader">
                                <th colSpan={10}>
                                    Modify Aadhaar Details for {getFormattedDate()}
                                </th>
                            </tr>
                            <tr className="tableheader">
                                <th>Sl No</th>
                                <th>FPS Id</th>
                                <th>RC No</th>
                                <th>Member ID</th>
                                <th>RC Member Name</th>
                                <th>eKYC Member Name</th>
                                <th>eKYC UID</th>
                                <th>RC UID</th>
                                <th>Gender</th>
                                <th>Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {paginatedData.map((row, index) => (
                                <tr key={index}>
                                    <td>
                                        {rowsPerPage === "all"
                                            ? index + 1
                                            : page * rowsPerPage + index + 1}
                                    </td>
                                    <td align="left">{row.fpsId}</td>
                                    <td align="left">{row.rcId}</td>
                                    <td align="left">{row.memberId}</td>
                                    <td align="left">{row.rcMemberName || "-NA-"}</td>
                                    <td align="left">{row.poiName}</td>
                                    <td align="left">{row.uid}</td>
                                    <td align="left">{row.rcUid}</td>
                                    <td align="left">{row.gender}</td>
                                    <td align="left">{row.transTime?.substring(0, 10)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                    {/*  Pagination */}
                    <div style={{ marginTop: "15px", textAlign: "right" }}>
                        <span style={{ marginRight: "15px" }}>
                            Showing {total === 0 ? 0 : start} to {end} of {total}
                        </span>

                        <button
                            disabled={page === 0}
                            onClick={() => setPage(page - 1)}
                        >
                            Prev
                        </button>

                        <span style={{ margin: "0 10px" }}>
                            Page {page + 1}
                        </span>

                        <button
                            disabled={
                                rowsPerPage !== "all" &&
                                (page + 1) * rowsPerPage >= total
                            }
                            onClick={() => setPage(page + 1)}
                        >
                            Next
                        </button>

                        <select
                            value={rowsPerPage}
                            onChange={(e) => {
                                setRowsPerPage(
                                    e.target.value === "all"
                                        ? "all"
                                        : parseInt(e.target.value, 10)
                                );
                                setPage(0);
                            }}
                            style={{ marginLeft: "10px" }}
                        >
                            <option value={10}>10</option>
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                            <option value="all">All</option>
                        </select>
                    </div>
                </>
            )}

        </div>
    );
};

export default Date_Wise_Ben_Ver;